var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/hover-status-wrapper.tsx";
import classNames from 'classnames';
import { debounce } from 'lodash';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { openStatusHoverCard, closeStatusHoverCard } from 'soapbox/actions/status-hover-card';
import { isMobile } from 'soapbox/is_mobile';
const showStatusHoverCard = debounce((dispatch, ref, statusId) => {
  dispatch(openStatusHoverCard(ref, statusId));
}, 300);
/** Makes a status hover card appear when the wrapped element is hovered. */
export const HoverStatusWrapper = ({
  statusId,
  children,
  inline = false,
  className
}) => {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const Elem = inline ? 'span' : 'div';
  const handleMouseEnter = () => {
    if (!isMobile(window.innerWidth)) {
      showStatusHoverCard(dispatch, ref, statusId);
    }
  };
  const handleMouseLeave = () => {
    showStatusHoverCard.cancel();
    setTimeout(() => dispatch(closeStatusHoverCard()), 200);
  };
  const handleClick = () => {
    showStatusHoverCard.cancel();
    dispatch(closeStatusHoverCard(true));
  };
  return /*#__PURE__*/React.createElement(Elem, {
    ref: ref,
    className: classNames('hover-status-wrapper', className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 5
    }
  }, children);
};
export { HoverStatusWrapper as default, showStatusHoverCard };